import { Button, Flex, RangeCalendar, Stack } from '@eleveo/components-react';
import { CrossIcon } from '@eleveo/icons-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { DateRangeFilter } from '../../../utils/filter';
import type { AccordionItemBaseProps, AccordionProps } from '@eleveo/components-react';
// eslint-disable-next-line import/no-extraneous-dependencies
import type { DateValue } from '@internationalized/date';

export type DateRangeFilterTileProps =
  // Accordion item props
  AccordionProps<AccordionItemBaseProps>['items'][number] & {
    minValue?: DateValue;
    maxValue?: DateValue;
    setValues: (value: React.SetStateAction<DateRangeFilter>) => void;
    values: DateRangeFilter;
  };

export const DateRangeFilterTile = ({ minValue, maxValue, testId, setValues, values }: DateRangeFilterTileProps) => {
  const { t } = useTranslation();

  return (
    <Stack className="w-full px-20 pt-10 pb-15" direction="vertical" spacing={15}>
      <Flex justifyContent="center">
        <RangeCalendar
          testId={`${testId}:calendar`}
          maxValue={maxValue}
          minValue={minValue}
          onChange={(range) => {
            setValues(range as DateRangeFilter);
          }}
          value={values}
        />
      </Flex>

      {values && (
        <Button
          testId={`${testId}:clear:button`}
          onClick={() => setValues(null as unknown as DateRangeFilter)}
          color="info"
          variant="quiet"
          isSmall
          className="mr-auto"
        >
          <CrossIcon />
          {t('form.clear')}
        </Button>
      )}
    </Stack>
  );
};
